import React from 'react';
import * as Styled from './UnitPicker.styles';
export var units = [{
  label: 'CM',
  shortcode: 'cm'
}, {
  label: 'IN',
  shortcode: '"'
}];
export var renderUnit = function renderUnit(numbers) {
  var activeUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return "".concat(numbers[activeUnit]).concat(units[activeUnit].shortcode);
};
export var renderSize = function renderSize(size) {
  var activeUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return "".concat(size, " (").concat(units[activeUnit].label.toLowerCase(), ")");
};

var UnitPicker = function UnitPicker(_ref) {
  var activeUnit = _ref.activeUnit,
      changeUnit = _ref.changeUnit;
  return /*#__PURE__*/React.createElement("div", {
    className: "xs-row"
  }, /*#__PURE__*/React.createElement(Styled.SizeOptionLabel, {
    className: "xs-8--none"
  }, "View size chart in:"), /*#__PURE__*/React.createElement("p", {
    className: "xs-4--none text-right"
  }, /*#__PURE__*/React.createElement(Styled.SizeOption, {
    active: activeUnit === 1,
    onClick: function onClick() {
      return changeUnit(1);
    },
    "data-test": "component-sizes-unit-picker-1"
  }, units[1].label), /*#__PURE__*/React.createElement(Styled.SizeOption, {
    active: activeUnit === 0,
    onClick: function onClick() {
      return changeUnit(0);
    },
    "data-test": "component-sizes-unit-picker-0"
  }, units[0].label)));
};

export default UnitPicker;